import { createMultiStyleConfigHelpers, ThemingProps } from '@chakra-ui/react'
import { Spacing } from '~/types/ThemeTypes'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const newFaxFormStyleParts = [
  'container',
  'toInput',
  'phoneNameText',
  'phoneNumberText',
] as const

const helpers = createMultiStyleConfigHelpers(newFaxFormStyleParts)
export const NewFaxFormStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      alignItems: 'stretch',
      gap: Spacing._2,
    },
    toInput: {
      height: '3.5rem',
    },
    phoneNameText: {
      fontWeight: '900',
      noOfLines: 1,
    },
    phoneNumberText: {
      flexShrink: 0,
    },
  },
})

const themeKey = getName({ NewFaxFormStyle })
export const useNewFaxFormStyle = (props?: ThemingProps) =>
  useCustomMultiStyleConfig<typeof newFaxFormStyleParts>(themeKey, props)

export const createNewFaxFormStyleContext = () =>
  createCustomStyleContext<typeof newFaxFormStyleParts>(themeKey)
